import React from 'react';
import { Search } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/Card/Card';

export function EmptySearchState() {
  return (
    <Card>
      <CardContent className="py-12 text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center">
            <Search className="w-8 h-8 text-primary-600" />
          </div>
        </div>
        <h3 className="text-lg font-semibold mb-2">Search Across All Destinations</h3>
        <p className="text-muted-foreground max-w-sm mx-auto">
          Enter your requirements above and click "Search AI" to find venues across all your destinations simultaneously.
        </p>
      </CardContent>
    </Card>
  );
}

